export const roleTypes = {
  ADMINISTRATOR: 'admin',
  USER: 'user',
  TENANT_ADMIN: 'tenant-admin',
}

export const roleLabels: Record<string, string> = {
  [roleTypes.USER]: 'Benutzer',
  [roleTypes.TENANT_ADMIN]: 'Mandantenadministrator',
  [roleTypes.ADMINISTRATOR]: 'Administrator',
}
